import type { GroupChannel } from "@sendbird/chat/groupChannel";

interface UserMetadata {
  role?: "MENTEE" | "MENTOR" | "admin";
  isSupervisor?: boolean;
  check_in_frequency?: string;
}

export function shouldShowCheckinBadge(
  channel: GroupChannel,
  currentUserId: string,
): boolean {
  const otherMember = channel.members.find(
    (member) => member.userId !== currentUserId,
  );
  const metadata = otherMember?.metaData as UserMetadata;

  // If no check-in frequency is set, don't show badge
  if (
    !metadata?.check_in_frequency ||
    metadata?.check_in_frequency === "not_sure"
  ) {
    return false;
  }

  // If no last message, show badge to indicate need for check-in
  const lastMessage = channel.lastMessage;
  if (!lastMessage) {
    return true;
  }

  const lastMessageDate = new Date(lastMessage.createdAt);
  const now = Date.now();
  const timeSinceLastMessage = now - lastMessageDate.getTime();

  const twelveHours = 12 * 60 * 60 * 1000;
  const twoDays = 2 * 24 * 60 * 60 * 1000;
  const fourDays = 4 * 24 * 60 * 60 * 1000;

  // Show badge based on frequency and time since last message
  switch (metadata.check_in_frequency) {
    case "daily":
      return timeSinceLastMessage >= twelveHours;
    case "few_days":
      return timeSinceLastMessage >= twoDays;
    case "once_in_while":
      return timeSinceLastMessage >= fourDays;
    default:
      return false;
  }
}
